export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            Dlaczego warto wybrać nasz Kakobuy Spreadsheet?
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto">
            Porównaj różne metody wyszukiwania produktów i przekonaj się, która jest najskuteczniejsza.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full max-w-3xl mx-auto border-collapse">
            <thead>
              <tr className="border-b-2 border-background-300/60">
                <th className="text-left py-4 px-4 text-sm font-label font-semibold text-foreground-700">Metoda</th>
                <th className="text-left py-4 px-4 text-sm font-label font-semibold text-foreground-700">Czas</th>
                <th className="text-left py-4 px-4 text-sm font-label font-semibold text-foreground-700">Ryzyko</th>
                <th className="text-left py-4 px-4 text-sm font-label font-semibold text-foreground-700">Efektywność</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-200/70">
                <td className="py-4 px-4 text-sm text-foreground-700">Szukanie ręczne</td>
                <td className="py-4 px-4">
                  <span className="inline-flex items-center gap-1.5 text-sm text-accent-600">
                    <i className="ri-timer-line"></i>
                    Kilka godzin
                  </span>
                </td>
                <td className="py-4 px-4">
                  <span className="inline-flex items-center gap-1.5 text-sm text-accent-600">
                    <i className="ri-error-warning-line"></i>
                    Wysokie
                  </span>
                </td>
                <td className="py-4 px-4">
                  <span className="inline-flex items-center gap-1.5 text-sm text-foreground-500">
                    <i className="ri-star-line"></i>
                    Niska
                  </span>
                </td>
              </tr>
              <tr className="border-b border-background-200/70">
                <td className="py-4 px-4 text-sm text-foreground-700">Social media</td>
                <td className="py-4 px-4">
                  <span className="inline-flex items-center gap-1.5 text-sm text-accent-600">
                    <i className="ri-timer-line"></i>
                    Dużo chaosu
                  </span>
                </td>
                <td className="py-4 px-4">
                  <span className="inline-flex items-center gap-1.5 text-sm text-accent-500">
                    <i className="ri-error-warning-line"></i>
                    Średnie
                  </span>
                </td>
                <td className="py-4 px-4">
                  <span className="inline-flex items-center gap-1.5 text-sm text-foreground-500">
                    <i className="ri-star-half-line"></i>
                    Średnia
                  </span>
                </td>
              </tr>
              <tr>
                <td className="py-4 px-4 text-sm font-semibold text-primary-700">Kakobuy Spreadsheet</td>
                <td className="py-4 px-4">
                  <span className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-semibold">
                    <i className="ri-timer-flash-line"></i>
                    Kilka minut
                  </span>
                </td>
                <td className="py-4 px-4">
                  <span className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-semibold">
                    <i className="ri-shield-check-line"></i>
                    Niskie
                  </span>
                </td>
                <td className="py-4 px-4">
                  <span className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-semibold">
                    <i className="ri-star-fill"></i>
                    Wysoka
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}